var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice8Sided(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    title: "D8 by Lonnie Tapscott from NounProject.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m329.67 199.86c-1.4961-6.1523-0.40234-12.648 3.0234-17.977-7.2617 0.21484-14.473-1.3398-21-4.5352-4.6602-2.4414-8.9141-5.5938-12.598-9.3516-6.6602-6.3438-9.7812-15.555-8.3438-24.641 1.418-8.9219 7.9141-16.688 19.488-23.297h-0.003907c10.195-6.3359 22.258-8.9648 34.16-7.4453 10.453 1.2695 20.137 6.1406 27.387 13.773 3.2695 3.5898 5.8477 7.7461 7.6133 12.266 1.9023 5.3789 1.3906 11.32-1.3984 16.297 8.0039-0.47266 16.008 0.88672 23.406 3.9766 7.2227 2.9805 13.703 7.5117 18.984 13.27 7.6094 7.3398 11.27 17.859 9.8555 28.336-1.5664 10.23-8.8125 19.039-21.727 26.434-10.629 6.8242-23.316 9.7031-35.852 8.1367-12.535-1.5664-24.121-7.4766-32.746-16.707-5.0273-5.1406-8.5664-11.543-10.25-18.535zm48.328 12.938c5.5352 1.1328 11.297 0.13281 16.129-2.8008 4.5352-2.0352 7.6914-6.2734 8.3438-11.199-0.082031-5.4844-2.457-10.688-6.5508-14.336-4.0781-4.7578-9.5742-8.0742-15.684-9.4648-5.5117-1.0234-11.211 0.011719-16.016 2.9102-4.5 2.0781-7.6406 6.2969-8.3438 11.203 0.042969 5.582 2.4648 10.879 6.6641 14.559 4.0547 4.6055 9.4648 7.8047 15.457 9.1289zm-42.336-47.824c4.7695 0.82813 9.6797-0.085937 13.832-2.5781 3.9805-1.7617 6.7891-5.4375 7.4492-9.7422 0.10156-4.2461-1.6328-8.3281-4.7617-11.199-3.3125-3.8047-7.7773-6.418-12.711-7.4492-4.8398-0.80859-9.8047 0.14453-14 2.6875-3.9258 1.793-6.7266 5.3906-7.5039 9.6328-0.16797 4.4922 1.6797 8.8281 5.0391 11.816 3.2969 3.4883 7.6406 5.8086 12.375 6.6094zm255.14-15.344c-1.375-2.6914-3.7773-4.7109-6.6641-5.6016l-359.35-106.57c-5.875-1.7891-12.094 1.4805-13.945 7.3359l-106.73 348.54c-1.793 5.875 1.4805 12.094 7.3359 13.945l359.63 112.39c1.082 0.375 2.2188 0.56641 3.3633 0.55859 1.8203 0.003907 3.6133-0.46094 5.207-1.3438 2.6875-1.375 4.707-3.7773 5.5977-6.6641l106.4-354.03h0.003906c0.87109-2.8516 0.57031-5.9375-0.83984-8.5664zm-30.297 11.199-278.82 165.09-51.574-263.48zm-337.85-77.84 48.609 248.25-141.12 53.594zm-82.266 309.9 136.14-51.688 164.36 145.6zm326.54 102.04-179.76-159.27 277.09-164.36z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.292969,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.53125,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.460938,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.398438,
    y: 644,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.992188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.734375,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 386.832031,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.726562,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 425.769531,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.4375,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 459.03125,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 478.269531,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.65625,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice8Sided);
export default __webpack_public_path__ + "static/media/dice8sided.5a65555d11d7f9872f64a6740b73b1db.svg";
export { ForwardRef as ReactComponent };